module.exports = __webpack_public_path__ + "img/cross.dadea72.svg";